import Phaser from 'phaser';
import { COLORS, FONTS, GAME_WIDTH, fontStr } from '@/config';
import { abonnerNettstatus } from '@/pwa/nettstatus';

const PANEL_WIDTH = 360;
const BANNER_HEIGHT = 56;

export class OfflineBanner {
  private container?: Phaser.GameObjects.Container;
  private bg?: Phaser.GameObjects.Rectangle;
  private label?: Phaser.GameObjects.Text;
  private unsubscribe?: () => void;
  private erMontert = false;
  private synlig = false;
  private harVistOnlineToast = false;

  constructor(
    private scene: Phaser.Scene,
    private varslOnline?: () => void,
  ) {}

  mount(): void {
    if (this.erMontert) return;
    this.erMontert = true;

    const roomWidth = GAME_WIDTH - PANEL_WIDTH;
    const x = roomWidth / 2;
    const y = 16;

    this.container = this.scene.add.container(x, y).setDepth(50);
    this.container.setVisible(false);

    const w = Math.min(roomWidth - 32, 520);
    this.bg = this.scene.add
      .rectangle(0, 0, w, BANNER_HEIGHT, COLORS.ochre, 0.96)
      .setOrigin(0.5, 0)
      .setStrokeStyle(2, COLORS.wine, 0.8);
    this.container.add(this.bg);

    this.label = this.scene.add
      .text(0, BANNER_HEIGHT / 2, '↕ Offline — saver lokalt', {
        fontFamily: FONTS.hud,
        fontSize: fontStr(20),
        color: '#862736',
        fontStyle: '700',
      })
      .setOrigin(0.5);
    this.container.add(this.label);

    this.unsubscribe = abonnerNettstatus((online) => this.oppdaterStatus(online));
  }

  private oppdaterStatus(online: boolean): void {
    if (!this.container) return;
    const skalVises = !online;
    if (skalVises === this.synlig) return;
    this.synlig = skalVises;
    this.container.setVisible(skalVises);
    if (online && this.harVistOnlineToast === false && this.varslOnline) {
      this.varslOnline();
    }
    if (online) this.harVistOnlineToast = true;
    if (!online) this.harVistOnlineToast = false;
  }

  destroy(): void {
    this.unsubscribe?.();
    this.unsubscribe = undefined;
    this.container?.destroy(true);
    this.container = undefined;
    this.bg = undefined;
    this.label = undefined;
    this.erMontert = false;
    this.synlig = false;
  }
}
